import type { SeloId } from './tipos';

/** O selo redondo de cada evento (o brasão do cartão e do detalhe). Desenho próprio, traço em ouro. */
export function Selo({ id, grande = false, apagado = false }: { id: SeloId; grande?: boolean; apagado?: boolean }) {
  return (
    <span className={`ev-selo${grande ? ' ev-selo--g' : ''}${apagado ? ' ev-selo--off' : ''}`} aria-hidden="true">
      <svg viewBox="0 0 26 26" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        {id === 'ub' && (
          <>
            <path d="M8 19 L20 5" /><path d="M4.6 17.4 L9.4 21.2" /><path d="M4.4 21.6 L6.6 23.4" />
            <path d="M18 19 L6 5" /><path d="M21.4 17.4 L16.6 21.2" /><path d="M21.6 21.6 L19.4 23.4" />
          </>
        )}
        {id === 'invasao' && (<><path d="M4 22V11l3-2 3 2V7l3-3 3 3v4l3-2 3 2v11z" /><path d="M11 22v-5h4v5" /></>)}
        {id === 'chefe' && (<><path d="M5 19l-1-11 5 4 4-7 4 7 5-4-1 11z" /><path d="M5 22h16" /></>)}
        {id === 'penta' && (<><circle cx="13" cy="13.5" r="10" /><path d="M13 3.5 L18.9 21.6 L3.5 10.4 L22.5 10.4 L7.1 21.6 Z" /></>)}
      </svg>
    </span>
  );
}
